import { FieldType } from '@pmp/api';

export const PROCURATION_FEES_LIST_NAMES: FieldType[] = [
  FieldType.PROCURATION_FEES,
  FieldType.PROCURATION_FEE_RULES,
  FieldType.PROCURATION_FEE_ITEM_TYPE,
  FieldType.PROCURATION_FEE_UNIT,
  FieldType.PROCURATION_FEE_BASIS,
  FieldType.ENDING_TYPE,
  FieldType.OPERATION_TYPE,
  FieldType.APPLICATION_TYPE,
  FieldType.PROPERTY_PURPOSE,
  FieldType.YES_NO,
];
